<div class="mat-modal-dialog cancel-modal p-0">
    <h2 mat-dialog-title>
        <mat-icon style="color:#3399ff; float: right; cursor: pointer; position: relative; top: -10px;" (click)="onClickCancel()">close</mat-icon>
    </h2>
    <mat-dialog-content>
        <p> Do you want to logout ?</p>
    </mat-dialog-content>
    <div mat-dialog-actions align="end">
        <button type="button" class="btn footerBtn funcBtn" (click)="onConfirmation()">Yes</button>
        <button type="button" class="btn footerBtn cancel" (click)="onClickCancel()">No</button>
    </div>
</div>